import React from 'react';
import { XCircleIcon, CheckCircleIcon } from 'lucide-react';
export const Benefits = () => {
  return <section className="mb-10" data-id="element-21">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-22">
        Laat me eerlijk zijn: deze cursus is niet voor iedereen…
      </h2>

      <div className="bg-red-50 p-6 rounded-lg border border-red-200 mb-6" data-id="element-23">
        <h3 className="text-lg font-bold text-red-800 mb-4 flex items-center" data-id="element-24">
          <XCircleIcon className="w-5 h-5 mr-2" data-id="element-25" />
          Dit is NIET voor jou als je:
        </h3>
        <ul className="space-y-3" data-id="element-26">
          <li className="flex items-start" data-id="element-27">
            <span className="text-red-600 mr-2" data-id="element-28">•</span>
            <span data-id="element-29">Vindt dat een hond gewoon moet gehoorzamen</span>
          </li>
          <li className="flex items-start" data-id="element-30">
            <span className="text-red-600 mr-2" data-id="element-31">•</span>
            <span data-id="element-32">Liever corrigeert en commandeert</span>
          </li>
          <li className="flex items-start" data-id="element-33">
            <span className="text-red-600 mr-2" data-id="element-34">•</span>
            <span data-id="element-35">Denkt dat jij de baas moet zijn en je hond moet volgen</span>
          </li>
          <li className="flex items-start" data-id="element-36">
            <span className="text-red-600 mr-2" data-id="element-37">•</span>
            <span data-id="element-38">
              Op zoek bent naar snelle 'trucjes' in plaats van echte verandering
            </span>
          </li>
        </ul>
      </div>

      <div className="bg-green-50 p-6 rounded-lg border border-green-200 mb-6" data-id="element-39">
        <h3 className="text-lg font-bold text-green-800 mb-4 flex items-center" data-id="element-40">
          <CheckCircleIcon className="w-5 h-5 mr-2" data-id="element-41" />
          Dit is WEL voor jou als je:
        </h3>
        <ul className="space-y-3" data-id="element-42">
          <li className="flex items-start" data-id="element-43">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-44" />
            <span data-id="element-45">Het beste met je hond voorhebt</span>
          </li>
          <li className="flex items-start" data-id="element-46">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-47" />
            <span data-id="element-48">
              Bereid bent om verder te kijken dan snelle 'oplossingen'
            </span>
          </li>
          <li className="flex items-start" data-id="element-49">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-50" />
            <span data-id="element-51">
              Je hond écht wilt begrijpen — niet alleen zijn gedrag veranderen
            </span>
          </li>
          <li className="flex items-start" data-id="element-52">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-53" />
            <span data-id="element-54">Liever samenwerkt dan tegenwerkt</span>
          </li>
          <li className="flex items-start" data-id="element-55">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-56" />
            <span data-id="element-57">Een diepere vertrouwensband wilt opbouwen</span>
          </li>
          <li className="flex items-start" data-id="element-58">
            <CheckCircleIcon className="w-5 h-5 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-59" />
            <span data-id="element-60">Bereid bent om te investeren in jullie relatie</span>
          </li>
        </ul>
      </div>

      <a href="https://stresslessdogs.nl/lc-fb-adv2" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-4 rounded-lg transition duration-200 block text-center" target="_blank" rel="noopener noreferrer" data-id="element-61">
        Bekijk de cursus
      </a>
    </section>;
};